import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Twitter, Youtube, Instagram, MessageSquare, Phone, Mail, MapPin } from "lucide-react";
import { company, footerColumns } from "../mock";
import { Logo } from "./Header";
import { CATALOGUE_DOWNLOAD_URL } from "./CatalogueButtons";

const socials = [
  { icon: Linkedin, label: "LinkedIn" },
  { icon: Facebook, label: "Facebook" },
  { icon: Twitter, label: "Twitter" },
  { icon: Youtube, label: "YouTube" },
  { icon: Instagram, label: "Instagram" },
];

const Footer = () => {
  return (
    <footer className="bg-[#f4f4f4] text-[#4d4d4f]" data-testid="site-footer">
      <div className="container-dic pt-14 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-[1fr_1.15fr_1.15fr_1fr_1.35fr_1.5fr] gap-8">
          {footerColumns.map((col) => (
            <div key={col.heading}>
              <h6 className="footer-heading">{col.heading}</h6>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.path} className="footer-link">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h6 className="footer-heading">Call Us</h6>
            <ul className="space-y-2">
              <li><a href={`tel:${company.phone}`} className="footer-link flex items-center gap-2"><Phone size={13} /> {company.phoneDisplay}</a></li>
              <li><a href={`tel:${company.phone2}`} className="footer-link flex items-center gap-2"><Phone size={13} /> {company.phone2Display}</a></li>
              <li><a href={`mailto:${company.email}`} className="footer-link flex items-center gap-2 whitespace-nowrap text-[12.5px]"><Mail size={13} className="shrink-0" /> {company.email}</a></li>
            </ul>
            <h6 className="footer-heading mt-7">Working Hours</h6>
            <p className="text-[13px] leading-6">{company.hours}</p>
            <a href={CATALOGUE_DOWNLOAD_URL} className="footer-link inline-flex items-center gap-2 mt-4 font-bold text-[#7ab929]" data-testid="footer-catalogue">Download Catalogue (PDF)</a>
          </div>

          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <h5 className="text-[17px] font-bold text-[#231f20] mb-2">{company.name}</h5>
            <p className="text-[13px] leading-6 flex gap-2">
              <MapPin size={14} className="shrink-0 mt-1 text-[#7ab929]" />
              <span>Registered Office &amp; Works: {company.address}</span>
            </p>
            <p className="text-[12.5px] mt-2 text-[#6d6e71]">GST No: <span className="font-semibold text-[#4d4d4f]">{company.gst}</span></p>
            <a
              href={company.mapsUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-block mt-4 text-[12px] font-bold tracking-wide uppercase text-[#7ab929] hover:text-[#5f9a17] transition-colors"
            >
              Locate our factory &rsaquo;
            </a>
          </div>
        </div>

        <div className="flex justify-center gap-3 mt-12">
          {socials.map(({ icon: Icon, label }) => (
            <a
              key={label}
              href="#"
              aria-label={label}
              onClick={(e) => e.preventDefault()}
              className="w-9 h-9 rounded-full bg-[#6d6e71] text-white flex items-center justify-center hover:bg-[#7ab929] transition-colors"
            >
              <Icon size={15} />
            </a>
          ))}
        </div>
      </div>

      <div className="border-t border-[#e2e2e2] bg-white">
        <div className="container-dic py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <Logo />
            <p className="text-[11px] tracking-wide uppercase text-[#6d6e71] mt-2">
              Copyright &copy; {new Date().getFullYear()} {company.name}. All rights reserved.
            </p>
          </div>
          <ul className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[12.5px]">
            <li><Link to="/about" className="footer-link">Privacy Policy</Link></li>
            <li className="text-[#bbb]">|</li>
            <li><Link to="/about" className="footer-link">Terms of Use</Link></li>
            <li className="text-[#bbb]">|</li>
            <li><Link to="/contact" className="footer-link">Sitemap</Link></li>
            <li className="text-[#bbb]">|</li>
            <li className="flex items-center gap-2">
              Made in Medchal, Telangana
              <span className="inline-block w-8 h-3 bg-gradient-to-r from-[#7ab929] to-[#38b6b0] skew-x-[-12deg]" />
            </li>
          </ul>
        </div>
      </div>
      <div className="h-2 bg-[#8cc63f]" />

      {/* Floating side enquiry tab */}
      <Link
        to="/contact"
        className="enquiry-tab"
        aria-label="Send an Enquiry"
        data-testid="floating-enquiry-tab"
      >
        <MessageSquare size={16} />
        <span>Send an Enquiry</span>
      </Link>
    </footer>
  );
};

export default Footer;
